import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import Experiment from '../components/Experiment';
import { playExperiment } from '../actions';
import { getSelectedVariant, getUserIdentifier } from '../selectors';

interface DispatchProps {
  playExperiment: (experimentName: string, variant: string) => void;
}

const mapDispatchToProps: DispatchProps = { playExperiment };

export default connect(
  createStructuredSelector({
    variant: getSelectedVariant,
    userIdentifier: getUserIdentifier,
  }),
  mapDispatchToProps,
)(Experiment);
